'use strict';
(function () {
    App.controller('LifeRelatedCtrl', lifeRelatedCtrl);

    lifeRelatedCtrl.$inject = ['$scope', '$stateParams', '$timeout', '$state', '$rootScope', 'lifeInsuranceService', 'Blob', 'FileSaver'];

    function lifeRelatedCtrl($scope, $stateParams, $timeout, $state, $rootScope, lifeInsuranceService, Blob, FileSaver) {
        $scope.page = 'insurance';
        $scope.$emit('page', $scope.page);

        $scope.step = 'Powiązane deklaracje';
        $scope.$emit('step', $scope.step);

        $scope.link = 'root.life.list';
        $scope.$emit('link', $scope.link);

        $scope.declarationEntity = $stateParams.declarationEntity || null;
        console.log('[lifeRelatedCtrl]', '$scope.declarationEntity', angular.copy($scope.declarationEntity));

        $scope.declarations = [];
        lifeInsuranceService.getDeclarations().then(function (success) {
            console.log('[getDeclarations]', 'success', angular.copy(success));
            $scope.declarations = success.data.data;
        });

        $scope.getDeclaration = function(ev, declarationEntity) {
            if(ev){
                ev.preventDefault();
                ev.stopPropagation();
            }
            var declaration = declarationEntity.declaration, id = declaration.uuid,
                barcode = declaration.barcode;

            lifeInsuranceService.getDeclarationFile(id).then(function (response) {
                var data = new Blob([response.data], { type: 'application/pdf' });
                FileSaver.saveAs(data, 'Deklaracja_' + barcode + '.pdf');
            });
        };
    }
})();
